import merge from 'lodash/merge.js';

import ImpersonationSession from '@/store/modules/impersonationlog/ImpersonationSession.js';
import Collection from '@/store/quill/Collection.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('impersonation-sessions');

export default merge(Collection('ImpersonationSessions', ImpersonationSession), {
    state: {
        sort: {
            started_at: 'desc',
        },
    },

    getters: {
        ...collectionHelpers.getters,
    },

    actions: {
        fetch: collectionHelpers.actions.fetch(({ context, queryBuilder }) => {
            const { getters, rootGetters } = context;

            queryBuilder.sort(getters.queryBuilderSorting).setPagination(getters.paginate);

            if (rootGetters['ImpersonationLogView/hasFilters']) {
                queryBuilder.raw(rootGetters['ImpersonationLogView/filters']);
            }
        }),

        clearSort: collectionHelpers.actions.clearSort,
        paginateAndFetch: collectionHelpers.actions.paginateAndFetch,
    },

    mutations: {
        CLEAR_SORTING: collectionHelpers.mutations.CLEAR_SORTING,
    },
});
